import {Button} from '@yandex-delivery/blocks'
import React from 'react'

import type {Props} from './CloseButton.types'

const Base: React.FC<Props> = ({onClick, text}) => (
  // @ts-expect-error требуется рефактор чтобы хендлер не юзал ивент
  <Button fullWidth onClick={onClick} textVariant="body2" variant="ghost">
    {text}
  </Button>
)

export const CloseButton = React.memo(Base)
